import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=4af9e9d9"
import script from "./DomainList.vue?vue&type=script&lang=ts"
export * from "./DomainList.vue?vue&type=script&lang=ts"
import style0 from "./DomainList.vue?vue&type=style&index=0&id=4af9e9d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports